var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expand-alert-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.724,
    height: 14.724,
    viewBox: "0 0 14.724 14.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10900",
    "data-name": "Group 10900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37749",
    "data-name": "Path 37749",
    d: "M106.548,0V1.636h2.933L101.44,9.677l1.157,1.157,8.041-8.041V5.726h1.636V0Z",
    transform: "translate(-97.55)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37750",
    "data-name": "Path 37750",
    d: "M13.088,13.088H1.636V1.636H7.362V0H1.636A1.636,1.636,0,0,0,0,1.636V13.088a1.636,1.636,0,0,0,1.636,1.636H13.088a1.636,1.636,0,0,0,1.636-1.636V7.362H13.088Z",
    fill: "#4b4b4b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAlertIcon);
export default __webpack_public_path__ + "static/media/expand-alert-icon.a5607935.svg";
export { ForwardRef as ReactComponent };